var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column h-100"},[_c('HeaderTop'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('Lgpd',{attrs:{"config_button":false,"privacy_policy":{
                title: 'Política de privacidade',
                link: '/informacoes/politica-de-privacidade'
            },"cookies_policy":{
                title: 'Política de cookies',
                link: '/informacoes/politica-de-cookies'
            }}}),_vm._v(" "),_c('ModalLocation',{attrs:{"id":"modal-1"}}),_vm._v(" "),_c('ModalAge'),_vm._v(" "),_c('MenuBar',{staticClass:"d-block d-lg-none"}),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('Footer',{staticClass:"d-none d-lg-block"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }